<!--
  挂件 Pendant
-->
<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="挂件" name="挂件">
        <el-row>
          <el-col :span="24" class="my-middle">
            <el-checkbox
              v-bind:key="select.id"
              v-for="select in pendant"
              v-model="select.status"
              v-bind:label="select.name"
              style="width:150px;margin:10px"
              border
            ></el-checkbox>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-collapse v-model="forcollapse" wtfname="pendantFormActive">
              <MetalPendant v-if="pendant[0].status"/>
              <TransparentPendant v-if="pendant[1].status"/>
              <RubberPendant v-if="pendant[2].status"/>
              <AnotherPendant v-if="pendant[3].status"/>
            </el-collapse>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
import MetalPendant from "./Pendant/MetalPendant.vue";
import TransparentPendant from "./Pendant/TransparentPendant.vue";
import RubberPendant from "./Pendant/RubberPendant.vue";
import AnotherPendant from "./Pendant/AnotherPendant.vue";

export default {
  name: "Pendant",
  methods: {},
  components: {
    MetalPendant,
    TransparentPendant,
    RubberPendant,
    AnotherPendant
  },
  data() {
    return {
      forcollapse: ['金属挂件','透明挂件','橡胶挂件','其他挂件',],
      pendant: [
        { id: "MetalPendant", name: "金属挂件", status: false },
        { id: "TransparentPendant", name: "透明挂件", status: false },
        { id: "RubberPendant", name: "橡胶挂件", status: false },
        { id: "AnotherPendant", name: "其他挂件", status: false }
      ],
      pendantFormActive: ["金属挂件"]
    };
  }
};
</script>
<style scoped>
</style>
